import React, { useState, useEffect } from 'react';
import OfferAddon from '../../models/OfferAddon';
import { getApi } from '../../api/endpoints.js';
import Multiselect from 'multiselect-react-dropdown';

const FormPartialEdit = (props) => {
  const { offerAddon, setOfferAddon } = props;
  let offerAddonObj = new OfferAddon(offerAddon);
  const [branchesOptions, setBranchesOptions] = useState([]);
  const [addonsOptions, setAddonsOptions] = useState([]);
  const [offersOptions, setOffersOptions] = useState([]);
  const [branchesOptionsApi] = getApi("branches");
  const [addonOptionsApi] = getApi("addons");
  const [offerOptionsApi] = getApi("offers");
  const [discountConfiguration, setDiscountConfiguration] = useState('discount_amount')

  useEffect(() => {
    getBranchOptions();
    getAddonOptions();
  }, [])

  useEffect(() => {
    getOfferOptions(offerAddonObj.circle_id);
  }, [branchesOptions, offerAddon.circle_id])

  const getBranchOptions = async () => {
    try {
      let response = await branchesOptionsApi({ fields: "options" }).unwrap();
      setBranchesOptions(response.data.branches);
    } catch (error) {
    }
  }
  const getAddonOptions = async () => {
    try {
      let response = await addonOptionsApi({ fields: "options" }).unwrap();
      setAddonsOptions(response.data.addons);
    } catch (error) {
    }
  }

  const getOfferOptions = async (branch_id) => {
    try {
      let response = await offerOptionsApi({ filters: { branch_ids: [branch_id] }, fields: "options" }).unwrap();
      setOffersOptions(response.data.offers);
    } catch (error) {
    }
  }

  const validateValue = (field) => {
    offerAddonObj.validate(field);
  }

  const changeValue = (field, value) => {
    offerAddonObj[field] = value;
    validateValue(field);
    setOfferAddon(offerAddonObj.toStateJson());
  }

  const onAddonSelect = (selectedList, selectedItems) => {
    offerAddonObj.addon_id = selectedItems.id ;
    validateValue("addon_id");
    setOfferAddon(offerAddonObj.toStateJson());
  }

  const onBranchSelect = (selectedList, selectedOption) => {
    offerAddonObj.circle_id = selectedOption.id;
    validateValue('circle_id');
    setOfferAddon(offerAddonObj.toStateJson());
  }

  const onOfferSelect = (selectedList, selectedOption) => {
    offerAddonObj.offer_id = selectedOption.id;
    validateValue('offer_id');
    setOfferAddon(offerAddonObj.toStateJson());
  }

  const handleConfigurationType = (e) => {
    setDiscountConfiguration(e.target.value);
  }

  const selectedBranches = () => {
    return branchesOptions.filter((option) => option.id === offerAddonObj.circle_id);
  }

  const selectedAddons = () => {
    return addonsOptions.filter((option) => option.id === offerAddonObj.addon_id);
  }

  const selectedOffers = () => {
    return offersOptions.filter((option) => {
        return option.id === Number(offerAddonObj.offer_id);
    });
  }

  return <>
    <div className="mb-2 mt-3 row">
      <div className="mb-3 col-md-6">
        <label htmlFor="name" className="form-label mb-1">Addon</label>
        <Multiselect
          id="addon_id"
          options={addonsOptions}
          selectedValues={selectedAddons()}
          singleSelect={true}
          placeholder="Select addon"
          onSelect={(selectedList, selectedItems) => onAddonSelect(selectedList, selectedItems)}
          displayValue="name"
          customArrow={true}
          avoidHighlightFirstOption={true}
        />
        <div id="addon_id_help" className="form-text text-danger mt-0">
          {offerAddonObj.errors.addon_id}
        </div>
      </div>
      <div className="mb-3 col-md-6">
        <label htmlFor="circle_id" className="form-label mb-1">Circle</label>
        <Multiselect
          id="circle_id"
          options={branchesOptions}
          selectedValues={selectedBranches()}
          singleSelect={true}
          placeholder="Select circle"
          onSelect={(selectedList, selectedItem) => onBranchSelect(selectedList, selectedItem)}
          displayValue="name"
          showCheckbox={false}
          customArrow={true}
          avoidHighlightFirstOption={true}
          disable={true}
        />
        <div id="circle_id_help" className="form-text text-danger mt-0">
          {offerAddonObj.errors.circle_id}
        </div>
      </div>
      <div className="mb-3 col-md-6">
        <label htmlFor="offer_id" className="form-label mb-1">Offer</label>
        <Multiselect
          id='offer_id'
          options={offersOptions}
          selectedValues={selectedOffers()}
          singleSelect={true}
          placeholder="Select Offer"
          onSelect={(selectedList, selectedItem) => onOfferSelect(selectedList, selectedItem)}
          displayValue="name"
          customArrow={true}
          avoidHighlightFirstOption={true}
        />
        <div id="offer_id_help" className="form-text text-danger mt-0">
          {offerAddonObj.errors.offer_id}
        </div>
      </div>
      <div className="mb-3 col-md-12 d-flex  btn-group">
        <div className="pt-2 me-1 ms-1">
          <input
            className='btn-check'
            defaultChecked
            type="radio"
            id="type2"
            name="discount_type"
            value="discount_amount"
            onChange={handleConfigurationType}
          />
          <label className='btn btn-sm btn-outline-success' style={{ fontSize: '12px' }} htmlFor="type2">
            Configure By Discount Amount
          </label>
        </div>
        <div className="pt-2 me-1 ms-1">
          <input
            className='btn-check'
            type="radio"
            id="type1"
            name="discount_type"
            value="discount_percentage"
            onChange={handleConfigurationType}
          />
          <label className='btn btn-sm btn-outline-success' style={{ fontSize: '12px' }} htmlFor="type1">
            Configure By Discount Percentage
          </label>
        </div>
      </div>
      {
        discountConfiguration == 'discount_amount' && <div className="mb-3 col-md-6">
          <label htmlFor="discount_amount" className="form-label mb-1">Discount Amount</label>
          <input
            id="discount_amount"
            type="number"
            value={offerAddonObj.discount_amount}
            onChange={(e) => 
              changeValue('discount_amount', e.target.value) || 
              changeValue('discount_percentage', "") || 
              changeValue('percentage_max_discount_amount', "")
            }
            className="form-control form-control-sm font-size-12"
            aria-describedby="discountAmountHelp"
            placeholder='Enter Discount Amount'
             />
          <div id="schemeDescriptionHelp" className="form-text text-danger mt-0">
            {offerAddonObj.errors.discount_amount}
          </div>
        </div>
      }
      {discountConfiguration == 'discount_percentage' && <>
        <div className="mb-3 col-md-6">
          <label htmlFor="discount_percentage" className="form-label mb-1">Discount Percentage (%)</label>
          <input
            id="discount_percentage"
            value={offerAddonObj.discount_percentage}
            onChange={(e) => {changeValue('discount_percentage', e.target.value); changeValue('discount_amount', "")}}
            className="form-control form-control-sm font-size-12"
            aria-describedby="discount_percentage_help"
            placeholder='Enter Discount Percentage'
          />
          <div id="discount_percentage_help" className="form-text text-danger mt-0">
            {offerAddonObj.errors.discount_percentage}
          </div>
        </div>
        <div className="mb-3 col-md-6">
          <label htmlFor="percentage_max_discount_amount" className="form-label mb-1">Max Discount Amount</label>
          <input
            id="percentage_max_discount_amount"
            type="number"
            min='1'
            max='100'
            value={offerAddonObj.percentage_max_discount_amount}
            onChange={(e) => changeValue('percentage_max_discount_amount', e.target.value)}
            className="form-control form-control-sm font-size-12"
            placeholder='Enter Max Discount'
          />
        </div>
      </>}
      <div className="mb-3 col-md-6">
        <label htmlFor="start_date" className="form-label mb-1">Start Date</label>
        <input
          id="start_date"
          type="date"
          value={offerAddonObj.start_date}
          onChange={(e) => changeValue('start_date', e.target.value)}
          className="form-control form-control-sm font-size-12"
          aria-describedby="start_date_help"
        />
        <div id="start_date_help" className="form-text text-danger mt-0">
          {offerAddonObj.errors.start_date}
        </div>
      </div>
      <div className="mb-3 col-md-6">
        <label htmlFor="end_date" className="form-label mb-1">End Date</label>
        <input
          id="end_date"
          type="date"
          value={offerAddonObj.end_date}
          onChange={(e) => changeValue('end_date', e.target.value)}
          className="form-control form-control-sm font-size-12"
          aria-describedby="end_date_help"
        />
        <div id="end_date_help" className="form-text text-danger mt-0">
          {offerAddonObj.errors.end_date}
        </div>
      </div>
    </div>
  </>
}

export default FormPartialEdit;
